import { BaseEntity } from './base-entity';
import { AssessmentMemberData } from './assessment-member-data';

export class AssessmentDistributionRisk extends BaseEntity {
  assessmentId?: string; // used to help mock data
  rank: number;
  impact: number;
  probability: number;
  requiresPlan: boolean;
  riskAssessmentMembersData: Array<AssessmentMemberData>;
  estimatedCompletionMinutes: number;
  override: boolean;
}
